import React from 'react';
import * as Styled from './AskProductOrderDetailsMore.styles';

export interface AskProductOrderDetailsMoreProps {
  numberOfElements: number;
  onClick?: () => void;
}

export const AskProductOrderDetailsMore: React.FC<
  AskProductOrderDetailsMoreProps
> = ({ numberOfElements, onClick }) => {
  return (
    <Styled.Wrapper onClick={onClick}>
      <Styled.Cover>
        <Styled.NumberOfElements variant="tiny" fontWeight={400}>
          {numberOfElements}+
        </Styled.NumberOfElements>
      </Styled.Cover>
      <Styled.Caption variant="tiny" fontWeight={400}>
        See More
      </Styled.Caption>
    </Styled.Wrapper>
  );
};
